require("!!/home/ingvars/BNC-Lab/front/node_modules/script-loader/addScript.js")(require("!!/home/ingvars/BNC-Lab/front/node_modules/raw-loader/index.js!/home/ingvars/BNC-Lab/front/node_modules/chart.js/dist/Chart.js"))


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/script-loader!/home/ingvars/BNC-Lab/front/~/chart.js/dist/Chart.js
// module id = ../../../../script-loader/index.js!../../../../chart.js/dist/Chart.js
// module chunks = 2